
import { SerializedError } from '@reduxjs/toolkit'

const ErrorLayout = ({ error }: { error: SerializedError}) => {
    return (
        <>
            {error.message} (<u>Code:</u> <b>{error.name}</b>)
        </>
    )
}

export default ErrorLayout